module.exports = __webpack_public_path__ + "img/HC2010-182.6d66aeac.jpg";